import { useState } from 'react'
import styled from 'styled-components'
import Icon from '@/components/common/Icon'
import ButtonIcon from '@/components/common/ButtonIcon'
import { copyToClipboard } from '@/common/services/copyToClipboard'
import { device } from '@/common/constants/device'

const BaseCopyWrap = styled.div`
  width: 20px;
  height: 20px;

  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }

  ${Icon} {
    width: 100%;
    height: 100%;
  }
`
const BaseCopyButton = styled(ButtonIcon)`
  width: 20px;
  height: 20px;

  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }
`

const BaseCopy = ({ className, value, color }) => {
  const [isCopy, setIsCopy] = useState(false)

  const onCopyButtonClick = () => {
    copyToClipboard(value)
    setIsCopy(true)
    setTimeout(() => setIsCopy(false), 2000)
  }

  return (
    <BaseCopyWrap className={className}>
      {isCopy ? (
        <Icon icon="check" color="green" />
      ) : (
        <BaseCopyButton
          color={color}
          icon="copy-circle"
          onClick={onCopyButtonClick}
        />
      )}
    </BaseCopyWrap>
  )
}

export default BaseCopy
